import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  accordionButton: {
    position: 'relative',
    width: '100%',
    height: 52,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.other.spacing._16,
    backgroundColor: theme.white,
    borderRadius: 0,
    cursor: 'pointer',

    '&.isGrey': {
      backgroundColor: theme.colors.gray2[0],
    },
    '&.isDark': {
      backgroundColor: theme.colors.gray2[4],
    },

    '&:first-child': {
      borderTopLeftRadius: theme.other.spacing._16,
      borderTopRightRadius: theme.other.spacing._16,
    },

    '&:last-child': {
      borderBottomLeftRadius: theme.other.spacing._16,
      borderBottomRightRadius: theme.other.spacing._16,
    },

    '&:last-child hr': {
      display: 'none',
    },
  },
  isSecondary: {
    borderTop: `1px solid ${theme.colors.gray[1]}`,

    '&:first-child, &:last-child': {
      borderRadius: 0,
    },
  },

  arrowIcon: {
    marginLeft: 'auto',
    marginRight: /* eslint-disable-line local-rules/use-theme-tokens */ 3,

    '& > svg': {
      display: 'block',
    },
  },

  divider: {
    border: 'none',
    borderTop: `1px solid ${theme.colors.gray[1]}`,
    margin: `0 ${theme.other.spacing._16}px`,
    background: 'none',
    padding: 0,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,

    '.isGrey &': {
      borderTopColor: theme.colors.gray2[1],
    },
    '.isDark &': {
      borderTopColor: theme.colors.dark[4],
    },
  },
}));

export default useStyles;
